import { render, staticRenderFns } from "./NewCertificateCard.vue?vue&type=template&id=88371b9a&scoped=true"
import script from "./NewCertificateCard.vue?vue&type=script&lang=ts"
export * from "./NewCertificateCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88371b9a",
  null
  
)

export default component.exports